module.exports = __webpack_public_path__ + "media/images/flags/16/Austria-310f6045ac6de1fa74157a727f4737af.png";